import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";
import { MediaImage } from "@/components/Media";
import { PeepingLogo } from "@/components/PeepingLogo";
import { fmtMoney } from "@/components/Peep";

export function CreatorCard({ c }) {
  return (
    <Link to={`/app/c/${c.handle}`} data-testid={`creator-card-${c.handle}`} className="group relative block overflow-hidden rounded-2xl border border-white/10 bg-[#15121b]">
      <div className="relative h-36 w-full overflow-hidden">
        {c.cover_url ? <MediaImage url={c.cover_url} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" /> : <div className="h-full w-full bg-gradient-to-br from-[#6a00ff]/50 via-[#15121b] to-[#d42be8]/40" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#15121b] to-transparent" />
      </div>
      <div className="relative -mt-8 flex items-end gap-3 px-4 pb-4">
        <div className="h-14 w-14 shrink-0 overflow-hidden rounded-full ring-2 ring-[#d42be8]/70">
          {c.avatar_url ? <MediaImage url={c.avatar_url} className="h-full w-full object-cover" /> : <div className="h-full w-full bg-gradient-to-br from-[#6a00ff] to-[#d42be8]" />}
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate font-bold">{c.display_name}</p>
          <p className="truncate text-xs text-[#a7a0af]">@{c.handle}{c.content_count !== undefined ? ` · ${c.content_count} ${c.content_count === 1 ? "post" : "posts"}` : ""}</p>
        </div>
        {c.entitled ? (
          <span className="flex items-center gap-1 rounded-full bg-[#d42be8]/20 px-2 py-1 text-[0.6rem] font-bold text-[#f0a8fa]"><BadgeCheck size={12} /> Member</span>
        ) : c.plan?.purchasable ? (
          <span className="text-xs font-bold text-brand-gradient">{fmtMoney(c.plan.price)}/mo</span>
        ) : null}
      </div>
    </Link>
  );
}

export default function Creators() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/creators").then((r) => setRows(r.data.creators)).catch(() => setRows([]));
  }, []);
  return (
    <div data-testid="creators-screen" className="px-5 pt-6">
      <PeepingLogo className="w-28 items-start" showTagline={false} />
      <h1 className="mt-6 text-2xl font-extrabold">Creators</h1>
      <p className="text-sm text-[#a7a0af]">Come closer to the creators you love.</p>
      <div className="mt-5 flex flex-col gap-3">
        {rows === null && <p className="text-sm text-[#a7a0af]">Loading…</p>}
        {rows?.length === 0 && <p data-testid="creators-empty" className="text-sm text-[#a7a0af]">Creators are coming soon.</p>}
        {rows?.map((c) => <CreatorCard key={c.id} c={c} />)}
      </div>
    </div>
  );
}
